export const Props = () => ({
  //Высота заглушки
  height: {
    type: Number,
    default: 24,
  },

  //Значение закругления элемента
  radius: {
    type: Number,
    default: 8,
  },
});